<bizz-loader [showLoader]="showLoader" [fullscreen]="true"></bizz-loader>

<router-outlet>
</router-outlet>
